import { useAppSelector } from "@/redux/hooks";
import fallbackLogo from "@/assets/logo.png";
import { cn } from "@/utils";
import ThemeToggle from "@/components/themeToggle";

interface BrandHeaderProps {
  className?: string;
  compact?: boolean;
}

export default function BrandHeader({ className, compact }: BrandHeaderProps) {
  const tenant = useAppSelector((state) => state.tenant.loginTenant);
  const logo = tenant?.LogoUrl || fallbackLogo;

  return (
    <div className={cn("flex w-full items-center justify-between gap-3", className)}>
      <div className="flex min-w-0 items-center gap-3">
        <img
          src={logo}
          alt={tenant?.Name || "Logo"}
          className={cn(
            "rounded-xl object-contain",
            compact ? "h-8 w-8" : "h-11 w-11"
          )}
        />
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-[0.22em] text-checkout-muted">
            Assinatura
          </p>
          <p
            className={cn(
              "truncate font-display font-semibold text-checkout-fg",
              compact ? "text-sm" : "text-base"
            )}
          >
            {tenant?.Name || "Checkout"}
          </p>
        </div>
      </div>
      <ThemeToggle />
    </div>
  );
}
